import { Component, OnDestroy, OnInit } from '@angular/core';
import { BrandingService } from './core/services/branding.service';
import { Router } from '@angular/router';
import { PmaService } from './pma/pma.service';
import { combineLatest, Subscription } from 'rxjs';

/** Only these entry routes should send AmTrust clients to PolicyHub. */
const AMTRUST_RESIDENTIAL_ENTRY_PAGES = new Set(['renters', 'assurant', 'residential']);

@Component({
    selector: 'app-redirect',
    template: '',
    standalone: false
})
export class RedirectComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  constructor(
    private brandingService: BrandingService,
    private router: Router,
    private pmaService: PmaService,
  ) { }

  ngOnInit(): void {
    this.subscription = combineLatest([
      this.brandingService.availableForms$,
      this.brandingService.defaultStartingPage$,
      this.brandingService.isAmtrustClient$,
      this.brandingService.amtrustClientUrl
    ]).subscribe(([forms, value, isAmtrustClient, amtrustClientUrl]) => {
      const isResidentialEntry =
        (value && AMTRUST_RESIDENTIAL_ENTRY_PAGES.has(value)) ||
        (!value && forms.includes('residential'));

      if (isAmtrustClient && amtrustClientUrl && isResidentialEntry) {
        this.pmaService.redirectToAmtrustApp({
          parentUrl: window.location.origin,
          amtrustClientUrl: this.brandingService.normalizeAmtrustClientUrl(
            String(amtrustClientUrl),
          ),
        });
        return;
      }

      if (value) {
        this.router.navigateByUrl(value);
      } else {
        if (forms.includes('rent_guarantee')) {
          this.router.navigateByUrl('rentguarantee');
        } else if (forms.includes('residential')) {
          this.router.navigateByUrl('renters');
        } else if (forms.includes('commercial')){
          this.router.navigateByUrl('commercial');
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }
}
